let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iGtAf")).then(() => parcelRequire('ijh2V'));